// import React, { useContext } from "react";
// import Header from "../Components/Header";
// import Rightcontainer from "../Components/Rightcontainer";
// import { Link } from "react-router-dom";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";

// const Support = ({ handleShow }) => {
//   const theme = localStorage.getItem('theme')

//   // language 
//   const translations = {
//     hi: {
//       contact: 'नीचे दिए गए प्लेटफ़ॉर्म पर हमसे संपर्क करें।',
//       money: 'राशि डालें  ',
//       next: 'आगे बड़े ',
//       addAmount: 'राशि जोड़ी जानी है ',
//       referPerson: 'रेफ़रल | ',
//     },
//     en: {
//       contact: 'Contact Us At Below Platforms.',
//       money: 'Enter Amount',
//       next: 'Next',
//       addAmount: 'Amount to be added',
//       referPerson: 'Referral',
//     },
//   };

//   const { language } = useContext(LanguageContext);


//   // change theme 
//   const styles = {
//     backgroundColor: theme === 'light' ? '#d3e3fd' : 'black',
//     color: theme === 'light' ? 'black' : '#fff',
//   };
//   const styles1 = {
//     color: theme === 'light' ? 'black' : 'white',
//   };

//   return (
//     <div>
//       <div
//         className="leftContainer pt-5 mt-5"
//         style={styles}
//       >
//         <div className="supportNewLayout">

//           {/* TOP INFO CARD */}
//           <div className="helpTopCard">
//             <div className="helpLeftBar"></div>

//             <div className="helpContent">
//               <img src="./images/support.jpg" className="helpImg" />
//               <div>
//                 <h2 className="helpTitle">Need Help?</h2>
//                 <p className="helpSub">We are here for you 24/7</p>
//               </div>
//             </div>
//           </div>

//           {/* SUPPORT GRID */}
//           <div className="supportOptionGrid">

//             {/* Teligram */}
//             <a className="supportOptionCard" href={JSON.parse(localStorage.getItem("sitSetting")).supportTelegram}>
//               <div className="supportIcon emailBG">
//                 <img src="./images/telegram.png" alt="" />
//               </div>
//               <div className="supportText">
//                 <h5>Telegram Support</h5>
//                 <span>Expect a quick response</span>
//               </div>
//             </a>

//             {/* WhatsApp */}
//             {JSON.parse(localStorage.getItem("sitSetting"))?.whatsappSupport && (
//               <a
//                 className="supportOptionCard"
//                 target="_blank"
//                 href={JSON.parse(localStorage.getItem("sitSetting")).whatsappSupport}
//               >
//                 <div className="supportIcon">
//                   <img src="/images/whatsapp-new-.png" alt="" />
//                 </div>
//                 <div className="supportText">
//                   <h5>WhatsApp</h5>
//                   <span>Chat with us instantly</span>
//                 </div>
//               </a>
//             )}




//           </div>

//           {/* Email */}
//           {/* <a className="supportOptionCard" href="mailto:support@gmail.com">
//               <div className="supportIcon emailBG">
//                 <img src="./images/mail-new.png" alt="" />
//               </div>
//               <div className="supportText">
//                 <h5>Email Support</h5>
//                 <span>Expect a quick response</span>
//               </div>
//             </a> */}

//           {/* PHONE SUPPORT */}
//           {/* <div className="phone-banner">

//             <div className="phone-anim">
//               <img src="/images/phone.png" alt="" />
//             </div>

//             <div className="phone-content">
//               <span>Need direct help?</span>
//               <h4 style={{ margin: 0, fontWeight: 700 }}>Phone Support</h4>

//               <a
//                 className="phone-number"
//                 href={
//                   "tel:" +
//                   JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile
//                 }
//                 target="_blank"
//               >
//                 {JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile}
//               </a>
//             </div>

//             <a
//               href={
//                 "tel:" +
//                 JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile
//               }
//               className="call-btn"
//             >
//               Call Now
//             </a>

//           </div> */}

//         </div>

//       </div>
//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Support;


import React, { useContext } from "react";
import Rightcontainer from "../Components/Rightcontainer";
import { LanguageContext } from "../Components/LanguageContext";
import {
  BsArrowRightShort,
  BsChatDotsFill,
  BsEnvelopeFill,
} from "react-icons/bs";
import "../css/BoxSupport.css";


const Support = () => {
  const { language } = useContext(LanguageContext);

  const siteSetting = JSON.parse(
    localStorage.getItem("sitSetting") || "{}"
  );

  const translations = {
    hi: {
      help: "सपोर्ट सेंटर",
      sub: "हम आपकी सहायता के लिए 24x7 यहां हैं",
      whatsapp: "WhatsApp Chat",
      whatsappSub: "कुछ ही मिनटों में जवाब पाएं",
      telegram: "Telegram Support",
      telegramSub: "प्रोफेशनल सहायता प्राप्त करें",
      contactTitle: "हमसे यहां संपर्क करें",
      footer: "SECURE & VERIFIED SUPPORT",
      online: "हम आपकी सहायता के लिए ऑनलाइन हैं",
    },

    en: {
      help: "HELP CENTER",
      sub: "We're available 24/7 to assist you.",
      whatsapp: "WhatsApp Chat",
      whatsappSub: "Instant reply within minutes",
      telegram: "Telegram Support",
      telegramSub: "Get professional assistance",
      contactTitle: "CONTACT US AT BELOW PLATFORMS.",
      footer: "SECURE & VERIFIED SUPPORT",
      online: "We're always here to help!",
    },
  };

  const t = translations[language] || translations.en;

  const handleWhatsApp = () => {
    if (!siteSetting.whatsappSupport) return;

    window.open(
      siteSetting.whatsappSupport,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleTelegram = () => {
    if (!siteSetting.supportTelegram) return;

    window.open(
      siteSetting.supportTelegram,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="box-support-wrapper">
      <main className="box-support-content">

        {/* Help Center Banner */}
        <section className="box_support_banner">
          <img
            src="/images/help-support.png"
            alt="BOX Ludo Help Center"
            className="img-fluid"
          />
        </section>
        {/* <section className="box-support-banner">
          <div className="box-support-banner-glow" />

          <div className="box-support-banner-copy">
            <span className="box-support-banner-tag">
              <span className="box-support-live-dot" />
              BOX LUDO SUPPORT
            </span>

            <h1>
              {t.help}
            </h1>

            <p>{t.sub}</p>

            <div className="box-support-banner-underline" />
          </div>

          <div className="box-support-banner-art">
            <img
              src="/images/support.jpg"
              alt="BOX Ludo Help Center"
              className="box-support-banner-image"
            />
          </div>

          <span className="box-support-banner-orb box-support-orb-one" />
          <span className="box-support-banner-orb box-support-orb-two" />
        </section> */}

        {/* Contact Heading */}
        <div className="box-support-section-heading">
          <span className="box-support-heading-line" />
          <span className="box-support-heading-dot" />
          <h2>{t.contactTitle}</h2>
        </div>

        {/* Support Options */}
        <section className="box-support-options">

          {/* WhatsApp */}
          {siteSetting.whatsappSupport && (
            <button
              type="button"
              className="box-support-option box-support-whatsapp"
              onClick={handleWhatsApp}
              aria-label="Contact WhatsApp Support"
            >
              <span
                className="box-support-corner box-support-corner-tl"
                aria-hidden="true"
              />
              <span
                className="box-support-corner box-support-corner-br"
                aria-hidden="true"
              />

              <div className="box-support-option-icon box-support-whatsapp-icon">
                <img
                  src="/whatsapp.png"
                  alt=""
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />

                <BsChatDotsFill className="box-support-fallback-icon" />
              </div>

              <div className="box-support-option-copy">
                <h4>{t.whatsapp}</h4>
                <p>{t.whatsappSub}</p>
              </div>

              <div className="box-support-option-arrow">
                <BsArrowRightShort />
              </div>

              <span className="box-support-option-shine" />
            </button>
          )}

          {/* Telegram Support */}
          {siteSetting.supportTelegram && (
            <button
              type="button"
              className="box-support-option box-support-telegram"
              onClick={handleTelegram}
              aria-label="Contact Telegram Support"
            >
              <span
                className="box-support-corner box-support-corner-tl"
                aria-hidden="true"
              />
              <span
                className="box-support-corner box-support-corner-br"
                aria-hidden="true"
              />

              <div className="box-support-option-icon box-support-telegram-icon">
                <img
                  src="/tel.png"
                  alt=""
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />

                <BsEnvelopeFill className="box-support-fallback-icon" />
              </div>

              <div className="box-support-option-copy">
                <h4>{t.telegram}</h4>
                <p>{t.telegramSub}</p>
              </div>

              <div className="box-support-option-arrow">
                <BsArrowRightShort />
              </div>

              <span className="box-support-option-shine" />
            </button>
          )}

        </section>



        <div className="box-support-bottom-art">
          <img
            src="/images/support-help.png"
            alt="We're always here to help"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        </div>

        <section className="box_support_footer_banner">
          <img
            src="/images/help-support-bottom.png"
            alt="BOX Ludo Help Center"
            className="img-fluid"
          />
        </section>

        {/* Footer */}
        <div className="box-support-footer">
          <span className="box-support-footer-shield">✓</span>
          <span>{t.footer}</span>
        </div>

      </main>

      <div className="rightContainer hidden-mobile">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
